import * as React from "react";
const SvgLandslideOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M11 12 8 8H2v14h20l-6-8-5-2zm1.53 2.77L6 16.95l-2-.67v-1.89l2 .67 3.95-1.32 2.58 1.03zM7 10l1.57 2.09-2.57.86-2-.67V10h3zM4 20v-1.61l2 .67 9.03-3.01L18 20H4zM17 6V1l-5-1-3 2v4l3 2 5-2zm-6-2.93 1.42-.95 2.58.52v2.01l-2.77 1.11L11 4.93V3.07zM18.5 7 16 9v3l2.5 2 4.5-2V8l-4.5-1zm2.5 3.7-2.2.98-.8-.64V9.96l1-.8 2 .44v1.1z" />
  </svg>
);
export default SvgLandslideOutlined;
